import subscriptionModule from "../subscriptionModule";

const subscriptionConstant = {
    eventTypes: {
        showMembershipManagementMessaging: "showMembershipManagementMessaging"
    },
    context: {
        purchasePlatformIsDifferent: "purchasePlatformIsDifferent"
    }
};

subscriptionModule
    .constant("subscriptionConstant", subscriptionConstant);

export default subscriptionConstant;